<template>

    <form @submit.prevent="validateForm('new-password-form')" data-vv-scope="new-password-form">
        <h2 class="p-new-password__title">Nowe hasło</h2>

        <form-row>
            <form-row>
                <form-input
                    v-model="password"
                    label="Nowe hasło"
                    type="password"
                    ref="hasło"
                    data-vv-as="nowe hasło"
                    v-validate="'required|min:6'">
                </form-input>
                <form-input
                    v-model="password_confirmation"
                    label="Powtórz hasło"
                    type="password"
                    data-vv-as="nowe hasło"
                    v-validate="'required|confirmed:hasło'">
                </form-input>
            </form-row>
        </form-row>

        <form-row align="center">
            <v-btn
                class="p-new-password__btn"
                :loading="isLoading"
                has-loader
                role="submit"
                type="green">
                Zmień hasło
            </v-btn>
        </form-row>
    </form>

</template>


<script>

import {FormInput, FormRow} from 'Components/Form'
import VBtn from 'Components/VBtn'

export default {

    name: 'ViewNewPassword',

    data() {
        return {
            token: this.$route.query.token || '',
            password: '',
            password_confirmation: '',
            isLoading: false
        }
    },

    methods: {
        validateForm(scope) {
            this.isLoading = true

            this.$validator.validateAll(scope).then((result) => {
                if (result) {
                    this.$store.dispatch('PHT_PASSWORD_NEW', {
                        token: this.token,
                        password: this.password,
                        password_confirmation: this.password_confirmation
                    }).then((response) => {
                        this.$alert.success('Resetowanie hasła', response.data.message)
                        this.$router.push({name: 'Login', query: {email: response.data.data.email}})
                    }).catch((e) => {
                        this.$alert.error('Resetowanie hasła', e.response.data.message)
                        this.isLoading = false
                    })
                } else {
                    this.isLoading = false
                }
            })
        }
    },

    mounted() {
        if (!this.$route.query.token) {
            this.$router.push({name: 'Login'})
        }
    },

    components: {
        FormInput,
        FormRow,
        VBtn,
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.p-new-password {
    &__title {
        margin-bottom: 1.5em;
    }
    &__btn a {
        font-size: 16px;
    }
}

</style>
